import { useEffect, useState, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { t } from 'i18next';
import ArticleModal from '../utils/ArticleModal';
import EventManager from '../../libs/EventManager';
import useOverrideInAppLinks from '../../hooks/useOverrideInAppLinks';

import '../../styles/FAQs.scss';


export default function FAQs ({
  show,
  topFaq,
  faq,
  articles,
  onSubmit,
  innerRef,
}) {
  const [top, setTop] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [open, setOpen] = useState(false);
  const summaryRef = useRef(null);

  useOverrideInAppLinks(summaryRef.current, top);

  useEffect(() => {
    if (faq && Array.isArray(articles) && articles.length > 0) {
      const faqArticles = [...articles];
      const topIndex = topFaq ? faqArticles.findIndex(f => topFaq === f.id) : -1;
      if (topIndex >= 0) {
        const topArticle = faqArticles[topIndex];
        faqArticles.splice(topIndex, 1);
        let div = document.createElement('div');
        div.innerHTML = topArticle.body;
        const nodes = Array.from(div.children);
        let anchors = faq?.labels['anchor'] || [];
        anchors = anchors.map(anchor => anchor.split(':'));
        let summaryNodes = [];
        for (const anchor of anchors) {
          const indexes = anchor.map(tag => nodes.findIndex(node => node.id === tag)).filter(index => index >= 0);
          indexes.sort((a, b) => a - b);
          for (let i = 0; i < indexes.length; i+=2) {
            const start = indexes[i];
            if (i + 1 < indexes.length) {
              const end = indexes[i + 1];
              summaryNodes = [...summaryNodes, ...nodes.slice(start, end)];
            } else {
              summaryNodes = [...summaryNodes, ...nodes.slice(start)];
            }
          }
        }
        if (summaryNodes.length <= 0) {
          summaryNodes = nodes;
        }
        div = document.createElement('div');
        for (const node of summaryNodes) {
          div.appendChild(node);
        }
        setTop({
          ...topArticle,
          isFull: Array.isArray(faq?.labels['anchor']) && faq?.labels['anchor'].length > 0,
          summary: div.innerHTML
        });
      }
      setFaqs(faqArticles);
    } else {
      setTop(null);
      setFaqs(null);
    }
  }, [faq, articles]);

  function onFaqClick (faq) {
    setSelectedFaq(faq);
    setOpen(true);
    EventManager.clickMore(faq?.id);
  }

  if (!show) return null;

  const { title, body } = faq || {};
  return <Typography variant='root' className='faq-component' ref={innerRef}>
    {title && <div className='title'>{title}</div>}
    {top && <div className='faq'>
      <div ref={summaryRef} className='article' dangerouslySetInnerHTML={{ __html: top.summary }} />
      {top.isFull && <div className='full-text'><Button variant='text' color='secondary' onClick={() => onFaqClick(top)}>{t('form.full_text')}</Button></div>}
    </div>}
    {faqs?.length > 0 && <div className='faqs'>
      <div className='related'>{t('form.related')}</div>
      {faqs.map((faq, index) => <Box key={`${faq.id}-${index}`} className='related-faq'>
        <Button variant='text' color='secondary' onClick={() => onFaqClick(faq)} className='article'>{faq.title}</Button>
      </Box>)}
    </div>}
    <div className='need-help-container'>
      <div className='need-help'>{t('form.need_help')}</div>
      <div className='need-help-desc'>{body ? <div dangerouslySetInnerHTML={{ __html: body }} /> : t('form.need_help_desc')}</div>
      <Button variant='text' color='secondary' onClick={onSubmit}>{t('form.contact_support')}</Button>
    </div>
    <ArticleModal open={open} title={selectedFaq?.title} content={selectedFaq?.body} onClose={() => setOpen(false)} />
  </Typography>
}